if (!customElements.get('variant-picker')) {
  customElements.define(
    'variant-picker',
    class VariantPicker extends HTMLElement {
      constructor() {
        super();

        this.variantInputs = this.querySelectorAll('input[name="add"]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]'); // Optional, if you want to keep a button
        this.hideErrors = this.dataset.hideErrors === 'true';


          

        // Listen for changes in variant selection
        this.variantInputs.forEach((input) => {
          input.addEventListener('change', this.onVariantChange.bind(this));
        });
      }

      onVariantChange(evt) {
        const selectedVariantId = evt.target.value;

        // Disable the submit button (if it exists) during the add-to-cart process
        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
        }

        this.handleErrorMessage();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', selectedVariantId);
        formData.append('quantity', 1); // Default quantity to 1

        console.log("this.cart",this.cart); 

         if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
           console.log("active leme picker", document.activeElement)
          this.cart.setActiveElement();
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'variant-picker',
                productVariantId: selectedVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'variant-picker',
                productVariantId: selectedVariantId,
                cartData: response,
              });
            this.error = false;

            if (this.cart) {
              this.cart.renderContents(response);
            }

            this.unselectVariant(evt.target);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (this.submitButton) {
              this.submitButton.classList.remove('loading');
              
              this.submitButton.removeAttribute('aria-disabled');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }


       unselectVariant(selectedInput) {
    // Uncheck the selected radio button
    selectedInput.checked = false;

    // Optionally, reset the variant selection UI
    this.variantInputs.forEach((input) => {
      input.checked = false;
    });
  }
    }
  );
}